<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer title="Edit Stock Area">
      <form v-on:submit.prevent="doSubmit">
 <label for="" class="mt-2 labels">Code *</label>
        <b-form-input
          type="text"
          class="mb-1"
          v-model="model.areaCode"
          placeholder="Enter Code"
          name="areaCode"
          v-bind:class="errors.has('areaCode') ? 'is-invalid' : ''"
          v-validate="'required'"
        ></b-form-input>
        <label for="" class="mt-2 labels">Name *</label>
        <b-form-input
          type="text"
          class="mb-1"
          v-model="model.areaName"
          placeholder="Enter Area Name"
          name="areaName"
          v-bind:class="errors.has('areaName') ? 'is-invalid' : ''"
          v-validate="'required'"
        ></b-form-input>
        <label for="" class="mt-2 labels">address *</label>
        <input
          type="text"
          class="mb-1 form-control"
          v-model="model.areaAddress"
          placeholder="Enter address"
          name="areaAddress"
          v-bind:class="errors.has('areaAddress') ? 'is-invalid' : ''"
          v-validate="'required'"
        />
        <label for="" class="mt-2 labels">phone </label>
        <input
          type="text"
          v-model="model.areaPhone"
          class="mb-1 form-control"
          placeholder="Enter Phone"
        />
        <label for="" class="mt-2 labels">fax</label>
        <input
          type="text"
          v-model="model.areaFax"
          class="mb-1 form-control"
          placeholder="Enter Fax"
        />
        <label for="" class="mt-2 labels">account code *</label>
        <div
          class="form-group d-flex"
          style="height: 2.25rem"
        >
          <b-input
            list="journals"
            v-model="model.selectedJournalAccount"
            name="selectedJournalAccount"
            v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
            v-validate="'required'"
            placeholder="Journal Account"
            style="height: 100%"
            required
          />
          <datalist id="journals">
            <option
              v-for="(journal, index) in journalAccountList"
              :key="index"
              :value="journal.text"
            />
          </datalist>
          <p v-if="errors.has('selectedJournalAccount') !== null"></p>
        </div>
         <label for="" class="mt-2 labels">Note </label>
        <input
          type="text"
          v-model="model.areaNote"
          class="mb-1 form-control"
          placeholder="Enter Note"
        />
        <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        <b-button class="mt-3 float-right" variant="warning" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          stockArea: window.AppConfig.apiUrl + 'stock-area',
          journal: window.AppConfig.apiUrl + 'journal-account'
        },
        model: {
          uuid: null,
          areaCode: null,
          areaName: null,
          areaAddress: null,
          areaPhone:null,
          areaFax:null,
          areaNote: null,
          journalAccount: null,
          selectedJournalAccount: '',
        },
        journalAccountList: []
      }
    },
    mounted(){
      this.fetchJournalAccount()
    },
    methods: {
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            if (this.model.uuid !== null) {
              this.$http.patch(this.apiUrl.stockArea + '/' + this.model.uuid, {
                areaCode: this.model.areaCode,
                areaName: this.model.areaName,
                areaAddress: this.model.areaAddress,
                areaPhone: this.model.areaPhone,
                areaFax: this.model.areaFax,
                areaNote: this.model.areaNote,
                journalAccount: this.model.journalAccount,
              }).then(() => {
                this.$store.dispatch('notification/success', 'Stock Area has been updated.')
                this.hideModal()
                this.resetData()
                this.$emit('getStockArea')
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },

      fetchJournalAccount(){
      this.$http.get(this.apiUrl.journal + '?journalAccountType=D').then(resp=>{
        this.journalAccountList = []
        resp.data._embedded.journal_account.forEach(journal=>{
          this.journalAccountList.push({
            value: journal.uuid,
            text: journal.journalAccountType + ' - ' + journal.journalAccountCode + ' - ' + journal.journalAccountName
          })
        })
      }).catch(error => console.log(error))
    },
      resetData () {
        this.model.uuid = null
        this.model.areaCode = null
        this.model.areaName  = null
        this.model.areaAddress  = null
        this.model.areaPhone = null
        this.model.areaFax = null
        this.model.areaNote = null
        this.model.journalAccount = null
        this.model.selectedJournalAccount = null
        this.$validator.reset()
      },
      showModal(row) {
        this.fetchJournalAccount()
        this.model.uuid = row.uuid
        this.model.areaCode = row.areaCode
        this.model.areaName = row.areaName
        this.model.areaAddress  = row.areaAddress
        this.model.areaPhone = row.areaPhone
        this.model.areaFax = row.areaFax
        this.model.areaNote = row.areaNote
        this.model.journalAccount = row.journalAccount.uuid
        this.model.selectedJournalAccount = row.journalAccount.journalAccountName
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>